/* ================================================================
   SOLEPURE — gekapselte Sections: Interaktionen (Editor-fest)
   Idempotent (pro-Element-Flags), erfasst alle .sp-scope-Sections,
   reagiert im Theme-Editor auf shopify:section:load.
================================================================ */
(function(){
  if (window.__spScopedReady) return;
  window.__spScopedReady = true;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.12, rootMargin:'0px 0px -50px 0px'}) : null;

  function reveals(scope){
    scope.querySelectorAll('.sp-scope .rv').forEach(function(el){
      if (el.dataset.rvDone) return; el.dataset.rvDone = '1';
      if (io) io.observe(el); else el.classList.add('in');
    });
    setTimeout(function(){
      scope.querySelectorAll('.sp-scope .rv').forEach(function(el){ var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('in'); });
    }, 900);
  }

  function statement(scope){
    scope.querySelectorAll('.sp-scope .statement p').forEach(function(el){
      if (el.dataset.spStmt) return; el.dataset.spStmt = '1';
      var raw = el.textContent, html = '', hl = false;
      raw.split(/\s+/).forEach(function(word){
        if (!word) return; var w = word;
        if (w.indexOf('##') === 0) { hl = true; w = w.slice(2); }
        var closes = false; if (w.slice(-2) === '##') { closes = true; w = w.slice(0, -2); }
        html += '<span class="w' + (hl ? ' hl' : '') + '">' + w + '</span> ';
        if (closes) hl = false;
      });
      el.innerHTML = html.trim();
      var words = el.querySelectorAll('.w');
      if (RM) { words.forEach(function(w){ w.classList.add('lit'); }); return; }
      function onScroll(){
        var r = el.getBoundingClientRect(), vh = window.innerHeight, start = vh*.85, end = vh*.35;
        var total = r.height + (start - end);
        var p = Math.min(1, Math.max(0, (start - r.top) / total));
        var lit = Math.floor(p * words.length * 1.15);
        words.forEach(function(w, i){ w.classList.toggle('lit', i < lit); });
      }
      window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    });
  }

  function counters(scope){
    if (!('IntersectionObserver' in window)) return;
    var cio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return; var el = e.target, t = parseFloat(el.dataset.count), s = performance.now();
        (function step(n){ var p = Math.min(1,(n-s)/1900), ease = 1-Math.pow(1-p,3); el.textContent = Math.round(t*ease); if (p<1) requestAnimationFrame(step); })(s);
        cio.unobserve(el);
      });
    }, {threshold:.5});
    scope.querySelectorAll('.sp-scope [data-count]').forEach(function(n){ if (n.dataset.cDone) return; n.dataset.cDone = '1'; cio.observe(n); });
  }

  function faq(scope){
    scope.querySelectorAll('.sp-scope .faq').forEach(function(item){
      var btn = item.querySelector('.faq-btn'), body = item.querySelector('.faq-body');
      if (!btn || !body || btn.dataset.spFaq) return; btn.dataset.spFaq = '1';
      btn.addEventListener('click', function(){
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
      });
    });
  }

  function initAll(scope){ scope = scope || document; reveals(scope); statement(scope); counters(scope); faq(scope); }

  if (document.readyState !== 'loading') initAll(document); else document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  if (window.Shopify && Shopify.designMode) { document.addEventListener('shopify:section:load', function(e){ initAll(e.target); }); }
})();
